import { useNavigate } from "react-router-dom";
import { Sparkles, ChevronRight } from "lucide-react";
import PortalExit from "@/components/PortalExit";

const PALM =
  "https://customer-assets.emergentagent.com/job_f2410923-45b5-41a3-af61-0c43786e0f4d/artifacts/phtrtj13_Screenshot%202026-07-09%20at%209.56.10%E2%80%AFAM.png";

// The consumer-facing opening screen of the Palm Portal — the evocative hook
// that draws a guest in before they choose a hand and scan.
export default function PortalIntro() {
  const navigate = useNavigate();

  return (
    <div className="soma-grain relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-soma-surface px-5 py-12">
      <PortalExit />

      <div className="mb-8 max-w-lg text-center">
        <div className="mx-auto mb-6 h-32 w-24 overflow-hidden rounded-2xl border border-soma-brand/40 bg-[#EDE4D1] shadow-xl shadow-black/50">
          <img src={PALM} alt="" className="h-full w-full object-cover object-top" />
        </div>
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-soma-brand">// the palm portal</p>
        <h1 className="mt-3 font-display text-5xl italic leading-tight text-soma-on md:text-6xl">
          Do you have the mark of a witch?
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-soma-on2 md:text-base">
          In the center of the palm, a rare cross is said to appear in those who carry the sixth sense.
          Let the lines show you what you hold — your reading reveals your mystic markings.
        </p>
      </div>

      <button
        onClick={() => navigate("/portal/begin")}
        data-testid="portal-intro-begin"
        className="group flex items-center gap-2 rounded-full bg-soma-brand px-8 py-4 font-semibold text-soma-surface transition-opacity hover:opacity-90"
      >
        <Sparkles size={18} /> Discover your marks
        <ChevronRight size={18} className="transition-transform group-hover:translate-x-1" />
      </button>
      <p className="mt-4 text-xs text-soma-muted">A reflection, never a prediction.</p>

      <button
        onClick={() => navigate("/lore")}
        data-testid="portal-intro-lore"
        className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-soma-brand hover:text-soma-on"
      >
        Wander the old art
      </button>
    </div>
  );
}
